import {
  AirVent,
  Bug,
  Cctv,
  CloudRain,
  Flame,
  Hammer,
  HardHat,
  LampDesk,
  Paintbrush,
  Refrigerator,
  Sparkles,
  Sun,
  Trees,
  Video,
  Wrench,
  Zap,
} from "lucide-react";


export const residentServiceIcons = {
  AirVent,
  Refrigerator,
  Sparkles,
  Bug,
  Zap,
  Wrench,
  Paintbrush,
  Hammer,
  Cctv,
  Video,
  Sun,
  Trees,
  Flame,
  CloudRain,
  HardHat,
  LampDesk,
};